import React from 'react'

import * as commonStyles from '../components/styles'
import * as styles from './styles'

const Styled = {
  ...commonStyles,
  ...styles,
}

const errorViewContent: Record<string, { title: string; description: string; description_2: string }> = {
  default: {
    title: 'An error has occurred',
    description: 'We apologise, a technical error has occurred.',
    description_2:
      'Please check your internet connection and try reloading the page. If the problem persists, contact our customer service.',
  },
  '1': {
    title: 'Ett fel har inträffat',
    description: 'Vi ber om ursäkt, ett tekniskt fel har inträffat.',
    description_2:
      'Vänligen kontrollera din internetanslutning och försök att ladda om sidan. Om problemet kvarstår, kontakta vår kundservice.',
  },
  '2': {
    title: 'Ett fel har inträffat',
    description: 'Vi ber om ursäkt, ett tekniskt fel har inträffat.',
    description_2:
      'Vänligen kontrollera din internetanslutning och försök att ladda om sidan. Om problemet kvarstår, kontakta vår kundservice.',
  },
}

interface Props {
  channelId: string
}

const ErrorView: React.FC<Props> = ({ channelId }) => {
  const content = errorViewContent[channelId] ?? errorViewContent.default

  return (
    <Styled.ErrorView>
      <Styled.Intro>
        <h1>{content.title}</h1>
        <p>{content.description}</p>
        <p>{content.description_2}</p>
      </Styled.Intro>
    </Styled.ErrorView>
  )
}

export default ErrorView
